import { render, staticRenderFns } from "./CompositionsView.vue?vue&type=template&id=3c25a564&scoped=true"
import script from "./CompositionsView.vue?vue&type=script&lang=js"
export * from "./CompositionsView.vue?vue&type=script&lang=js"
import style0 from "./CompositionsView.vue?vue&type=style&index=0&id=3c25a564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25a564",
  null
  
)

export default component.exports